interface CarregandoProps {
  cartoes?: number;
  className?: string;
}

// Skeleton de vidro no formato da tela — nunca spinner sozinho, nunca tela branca.
// O brilho passa devagar por cima do bloco (shimmer), em vez de cinza parado.
export default function Carregando({ cartoes = 6, className = '' }: CarregandoProps) {
  return (
    <div className={`grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-3 ${className}`}>
      {Array.from({ length: cartoes }).map((_, i) => (
        <div
          key={i}
          className="overflow-hidden rounded-3xl border border-white/60 bg-white/60 backdrop-blur-sm"
        >
          <div className="esqueleto aspect-[4/3] w-full bg-secondary-200/70" />
          <div className="space-y-2 p-4">
            <div className="esqueleto h-3 w-16 rounded bg-secondary-200/70" />
            <div className="esqueleto h-5 w-3/4 rounded bg-secondary-200/70" />
            <div className="esqueleto h-3 w-1/2 rounded bg-secondary-200/70" />
          </div>
        </div>
      ))}
    </div>
  );
}